import { render, staticRenderFns } from "./Controls.vue?vue&type=template&id=6b888c40&scoped=true&lang=html&"
import script from "./Controls.vue?vue&type=script&lang=js&"
export * from "./Controls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b888c40",
  null
  
)

export default component.exports